

































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ConfirmGeneral extends Vue {
  confirmGeneralLoading = false;

  @Prop({ required: false, default: '' })
  confirmText!: string;

  @Prop({ required: false, default: false })
  closeParentFirst!: boolean;

  /* Needed to to be able to call `this.$parent.close()` below,
     * see https://github.com/buefy/buefy/issues/1184
     */
  public $parent: any;

  confirmAccept() {
    this.confirmGeneralLoading = true;
    // Todo: rewrite this. If closeParentFirst is true, we should simply set a timeout on emit
    if(this.closeParentFirst === true) {
      setTimeout(() => {
        this.$emit('confirmed-general', true);
        this.confirmGeneralLoading = false;
        this.$parent.close();
      }, 1200);
    } else {
      this.$emit('confirmed-general', true);
      this.confirmGeneralLoading = false;
      this.$parent.close();
    }
  }
}
